import { render } from "./recap.vue?vue&type=template&id=15ad7b87&scoped=true"
import script from "./recap.vue?vue&type=script&lang=js"
export * from "./recap.vue?vue&type=script&lang=js"

import "./recap.vue?vue&type=style&index=0&id=15ad7b87&lang=scss&scoped=true"

import exportComponent from "/usr/src/oho-accounting-test/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-15ad7b87"]])

export default __exports__